export const NEWS = {
  FETCH_NEWS: {
    MAIN: 'FETCH_NEWS',
    SUCCESS: 'FETCH_NEWS_SUCCESS',
    FAILURE: 'FETCH_NEWS_FAILURE'
  }

};
